export const NAVIGATION_ITEMS = [
   { id: 'home', translationKey: 'navigation.home' },
   { id: 'movie', translationKey: 'navigation.movie' },
   { id: 'tvShows', translationKey: 'navigation.tvShows' },
   { id: 'tvMiniSeries', translationKey: 'navigation.tvMiniSeries' },
   { id: 'tvSpecial', translationKey: 'navigation.tvSpecial' },
   { id: 'tvMovie', translationKey: 'navigation.tvMovie' },
   { id: 'tvShort', translationKey: 'navigation.tvShort' },
   { id: 'video', translationKey: 'navigation.video' },
   { id: 'videoGame', translationKey: 'navigation.videoGame' },
];
